<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="filter != 'all'"
          :color="filter == 'all' ? 'primary' : 'grey'"
          @click="filter = 'all'"
          class="ma-0 mr-1 mb-1"
        >{{$t('All')}}</v-btn>
        <v-btn
          depressed
          :outline="filter != 'facebook'"
          :color="filter == 'facebook' ? 'primary' : 'grey'"
          @click="filter = 'facebook'"
          class="ma-0 mr-1 mb-1"
        >
          <i class="fab fa-facebook-square mr-1"></i>
          {{$t('Facebook')}}
        </v-btn>
        <v-btn
          depressed
          :outline="filter != 'line'"
          :color="filter == 'line' ? 'primary' : 'grey'"
          @click="filter = 'line'"
          class="ma-0 mr-1 mb-1"
        >
          <i class="fab fa-line mr-1"></i>
          {{$t('Line')}}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-sm-right">
        <template v-if="loading">
          <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
        </template>
        <template v-else>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            v-tooltip.top="'Unlock to PREMIUM plan'"
            color="grey"
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{$t('export')}}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportDashboard"
            color="grey"
            outline
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{$t('export')}}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <date-filter :defaultFilter="'this_month'" v-model="selectedDate"></date-filter>
  <!-- {{selectedMenu}} -->
  <!-- <v-row align="center">
    <v-col cols="12">
      <v-select
        class="title"
        v-model="selectedMenu"
        :items="type"
        item-text="title"
        return-object
        :menu-props="{ top: true, offsetY: true }"
      ></v-select>
    </v-col>
  </v-row> -->
  
    <h3 style="margin: .5em;" class="title">{{$t(type[index].title)}}</h3>
    <TagReportGraph v-if="data.length" :selectedDate="sortedDate" :loading="loading" :data="data"/>

  </v-container>
</template>

<script>
import DateFilter from './DateFilter'
import TagReportGraph from './InboxStatGraph'

import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'

  export default {
    data() {
      return {

        index: 0,
        type: [
          { title:'คำถามเกี่ยวกับการสมัครเรียน', func: 'getbudashboardregisterquestion' },
          { title: 'คณะที่ถูกถาม', func: 'getbudashboardfaculty'},
          { title: 'ทุนการศึกษาที่ถูกถาม', func: 'getbudashboardscholarships'}
          ],
        filter: 'all',
        loading: false,
        selectedDate: {
          start: moment()
            .startOf('month')
            .format('YYYY-MM-DD'),
          end: moment()
            .endOf('month')
            .format('YYYY-MM-DD')
        },
        data: []
      }
    },
    watch: {
      selectedDate: {
        handler: function(newVal) {
          this.getRow(this.type[this.index])
        },
        deep: true
      },
      filter() {
        this.getRow(this.type[this.index])
      },
      index() {
        this.getRow(this.type[this.index])
      },
      selectedMenu() {
        this.getRow(this.selectedMenu)
      }
    },
    components: {
      DateFilter,
      TagReportGraph
    },
    computed: {
      ...mapGetters({
        selectedBot: 'selectedBot',
        currentLang: 'currentLang'
      }),
      sortedDate() {
        return this.data.sort((a,b)=>b.count-a.count)
      }
    },
    mounted() {
      this.getRow(this.type[this.index])
    },
    methods: {
      getRow(item) {
        let vm = this
        vm.loading = true
        api[item.func] ({...this.selectedDate, filter: vm.filter, pageid: vm.selectedBot.pageid }, function(error, response) {
          vm.loading = false
          if (error) {
            console.error(error)
            return
          }
          if (response.responsecode == 200) {
            vm.data = response.data
          }
        })
        
      },
      exportDashboard: function() {
        let vm = this
        let csvContent = ''
        if (vm.loading) {
          return false
        }

        if (vm.selectedDate.start)
        {
            csvContent +=
              'From,"' +
              moment(vm.selectedDate.start).format('DD/MM/YYYY') +
              '",To,"' +
              moment(vm.selectedDate.end).format('DD/MM/YYYY') +
              '"\r\n'
        }

        csvContent += 'Inbox Register Report by Date\r\n'
        csvContent += 'Intent, Count'+'\r\n'

        $.each(vm.data, function(index, item) {
          csvContent +=
            item.intent + ',' + item.count + '\r\n'
        })

        vm.exportCsv(csvContent, 'crm')
      }
    },
  }
</script>

<style scoped>
  .v-select__selection.v-select__selection--comma {
    color: #ff817c;
  }
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/InboxStatRegister.vue